import {Component, Input, OnInit} from '@angular/core';
import { AuthStore } from '../../shared/services/authentication/auth.store';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/authentication/auth.service';

/**
 * This component includes several ways to protect DOM:
 * by injecting token, by using attributes and structural components
 */
@Component({
  selector: 'dettaglioScontrinoFinaleCard',
  styles: [`


    .card-account {
      border-radius: 0px;
      border: solid 0px #0000000D;
      /* Add shadows to create the "card" effect */
      transition: 0.3s;
      -moz-box-shadow: 0px 0px 6px RGB(181, 181, 181);
      box-shadow: 0px 1px 6px RGB(181, 181, 181);
      -webkit-box-shadow: 0px 0px 6px RGB(181, 181, 181);
      -o-box-shadow: 0px 1px 6px RGB(181, 181, 181);

      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 300px;
      height: 120px;
      margin: 10px;
    }

    /* On mouse-over, add a deeper shadow */
    .card-scontrino:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    /* Add some padding inside the card container */



    /* Demo styles */

    ul {
      list-style: none;
      padding: 0;
    }

    b{
      font-size: 15px;
      vertical-align: 100%;
      padding-bottom: 5px;
      margin-bottom: 0px;
    }

    p{
      font-size: 15px;
      vertical-align: 100%;
      padding-bottom: 5px;
      margin-bottom: 0px;
    }

    p.due{
      font-size: 15px;
      vertical-align: 0px;
      padding-bottom: 0px;
      font-weight: lighter;
    }

    p.tre{
      font-size: 15px;
      vertical-align: 100%;
      padding-bottom: 5px;
      margin-bottom: 0px;
      font-weight: lighter;
    }

    .containerScontrino {
      padding-bottom: 10px;
      padding-top: 15px;
      padding-left: 5px;
      max-height: 50px;
      border-radius: 0px;
      horiz-align: left;
      float: left;
    }

    .center-cropped {
      background-position: center center;
      background-repeat: no-repeat;
      overflow: hidden;
      background-size: 400px;

    }

    h4{
      margin-bottom: 0px;
    }

    .header {
      display: inline-block;
      width: 100%;
      background: white;
    }
    .playerOne {
      float: right;
    }
    .playerTwo {
      float: left;
    }




    #container {
      text-align: center;
      max-width: 100%;
      margin: 0 auto;
    }

    .block {
      width: 100%;
      height: 80px;
      margin: 0px;
      margin-bottom: 1px;
      display: inline-flex;
      background: white;
      border-radius: 0px;
      font-size: 16px;
      align-items: center;
      justify-content: left;
      font-weight: bold;
      color: black;

      border-radius: 0px;
      border: solid 0px #0000000D;
      /* Add shadows to create the "card" effect */
      transition: 0.3s;
      -moz-box-shadow: 0px 0px 6px RGB(181, 181, 181);
      box-shadow: 0px 0px 6px RGB(181, 181, 181);
      -webkit-box-shadow: 0px 4px 4px RGB(220, 220, 220);
      -o-box-shadow: 0px 1px 6px RGB(181, 181, 181);


    }

    #store-locator {
      color: black;
    }



  `],
  template: `

    <div id="store-locator" class="block" (click)="clicco()">
      <div class="container" style="text-align: left">
        <h4 *ngIf="this.percent !== undefined" style="font-weight: lighter; margin-left: 10px;"><p style="color: #E95237; font-weight: bold; font-size: 16px">{{this.percent}}</p></h4>
        <h4 style="font-weight: lighter; margin-top: -5px; margin-left: 10px; color: grey; font-size: 10px;"><p style="font-weight: bold; font-size: 16px">{{this.nome}}</p></h4>
      </div>
      <p style="text-align: right; width:20%;  display: inline-block; background-color: white; border: none; color: black; font-size: 15px; padding-right: 0px; margin-right: 20px; font-weight: lighter">{{this.costo}} €</p>
    </div>
  `
})
export class DettaglioScontrinoFinaleCard implements OnInit{

  @Input() nome ;
  @Input() luogo ;
  @Input() link ;
  @Input() costo ;
  @Input() quantita;
  @Input() percentuale;

  public percent = '';

  constructor(
    // public authService: AuthService,
    private router: Router
  ) {

  }


  clicco(): void
  {
    console.log('porcodio');
  }
  /**
   * Simulate logout
   */

  ngOnInit(): void {
    if (this.percentuale !== undefined)
    {
      this.percent = this.percentuale + '%';
      console.log(this.percentuale + ' p0efirjoefrhnefqrw oi ' + this.percent);
    }
  }

}
